import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/maintenance.svg'


const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = { class: "container-fluid bg-black" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "vertical-center justify-content-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 col-lg-1 me-4 d-none d-sm-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "maintenance-icon rotate"
  })
], -1)
const _hoisted_9 = { class: "col-12 col-sm-10" }
const _hoisted_10 = { class: "maintenance-header" }
const _hoisted_11 = { class: "maintenance-body" }
const _hoisted_12 = { class: "container-fluid p-0 bg-black position-absolute bottom-0 start-0 footer-container" }
const _hoisted_13 = { class: "container" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-4" }
const _hoisted_16 = { class: "small mb-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" T:")
const _hoisted_19 = {
  class: "visible-xs-inline",
  href: "tel:{{ phone }}}"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" E:")
const _hoisted_22 = { href: "mailto:{{ email }}" }
const _hoisted_23 = { class: "col-8" }
const _hoisted_24 = { class: "small mb-3" }
const _hoisted_25 = { class: "small mb-3" }

export function render(_ctx: any,_cache: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("header", null, [
          _createElementVNode("img", {
            src: _ctx.logo,
            alt: "Wealthtime logo",
            class: "logo-img"
          }, null, 8, _hoisted_4)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.header), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.content), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("footer", null, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", _hoisted_16, [
                _createTextVNode(_toDisplayString(_ctx.copyright) + " ", 1),
                _hoisted_17,
                _hoisted_18,
                _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.phone), 1),
                _hoisted_20,
                _hoisted_21,
                _createElementVNode("a", _hoisted_22, _toDisplayString(_ctx.email), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.fcaRegistrationInformation), 1),
              _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.phoneCharges), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}